"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFormatDialog = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var positioning_1 = require("../../typings/positioning");
var positioning_2 = require("../../utils/positioning");
var Button_1 = require("../../Button");
var Overlay_1 = require("../../Overlay");
var Preview_1 = tslib_1.__importDefault(require("./previewSection/Preview"));
var FormatInput_1 = tslib_1.__importDefault(require("./FormatInput"));
var DocumentationLink_1 = tslib_1.__importDefault(require("./DocumentationLink"));
var CustomFormatDialog = /** @class */ (function (_super) {
    tslib_1.__extends(CustomFormatDialog, _super);
    function CustomFormatDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            format: _this.props.formatString || "",
        };
        _this.onApply = function () {
            _this.props.onApply(_this.state.format);
        };
        _this.isApplyButtonDisabled = function () {
            return _this.props.formatString === _this.state.format || _this.state.format === "";
        };
        _this.onFormatChange = function (format) {
            _this.setState({ format: format });
        };
        return _this;
    }
    CustomFormatDialog.prototype.render = function () {
        var _a = this.props, anchorEl = _a.anchorEl, positioning = _a.positioning, onCancel = _a.onCancel, separators = _a.separators, templates = _a.templates, documentationLink = _a.documentationLink, intl = _a.intl;
        var format = this.state.format;
        return (react_1.default.createElement(Overlay_1.Overlay, { closeOnParentScroll: true, closeOnMouseDrag: true, closeOnOutsideClick: true, alignTo: anchorEl, alignPoints: positioning_2.positioningToAlignPoints(positioning), onClose: onCancel },
            react_1.default.createElement("div", { className: "gd-dropdown overlay" },
                react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-body s-custom-format-dialog-body" },
                    react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-header" },
                        react_1.default.createElement("span", null, intl.formatMessage({ id: "measureNumberCustomFormatDialog.title" }))),
                    react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-content" },
                        react_1.default.createElement(FormatInput_1.default, { format: format, templates: templates, separators: separators, onFormatChange: this.onFormatChange }),
                        documentationLink && react_1.default.createElement(DocumentationLink_1.default, { url: documentationLink }),
                        react_1.default.createElement(Preview_1.default, { format: format, separators: separators })),
                    react_1.default.createElement("div", { className: "gd-measure-custom-format-dialog-footer" },
                        react_1.default.createElement(Button_1.Button, { className: "gd-button-secondary gd-button-small s-custom-format-dialog-cancel", onClick: onCancel, value: intl.formatMessage({ id: "cancel" }) }),
                        react_1.default.createElement(Button_1.Button, { className: "gd-button-action gd-button-small s-custom-format-dialog-apply", onClick: this.onApply, value: intl.formatMessage({ id: "apply" }), disabled: this.isApplyButtonDisabled() }))))));
    };
    CustomFormatDialog.defaultProps = {
        positioning: [
            { snapPoints: { parent: positioning_1.SnapPoint.CenterRight, child: positioning_1.SnapPoint.CenterLeft } },
            { snapPoints: { parent: positioning_1.SnapPoint.TopRight, child: positioning_1.SnapPoint.TopLeft } },
            { snapPoints: { parent: positioning_1.SnapPoint.BottomRight, child: positioning_1.SnapPoint.BottomLeft } },
        ],
    };
    return CustomFormatDialog;
}(react_1.default.PureComponent));
exports.CustomFormatDialog = CustomFormatDialog;
//# sourceMappingURL=CustomFormatDialog.js.map